(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  /* ---------- nedtællinger ---------- */
  function initTimer(el) {
    if (el.dataset.on) return;
    el.dataset.on = '1';
    var mins = parseFloat(el.dataset.minutes || '10');
    var loop = el.dataset.loop === 'true';
    var span = el.querySelector('[data-timer-clock]');
    var bar = el.querySelector('[data-timer-bar]');
    var total = mins * 60 * 1000;
    var key = 'ak-timer-' + (el.dataset.key || 'default');
    var end = parseInt(sessionStorage.getItem(key) || '0', 10);
    if (!end || end - Date.now() <= 0) {
      end = Date.now() + total;
      sessionStorage.setItem(key, String(end));
    }
    function tick() {
      var left = end - Date.now();
      if (left <= 0) {
        if (loop) {
          end = Date.now() + total;
          sessionStorage.setItem(key, String(end));
          left = total;
        } else {
          left = 0;
        }
      }
      if (span) span.textContent = pad(Math.floor(left / 60000)) + ':' + pad(Math.floor(left / 1000) % 60);
      if (bar) bar.style.width = Math.max(0, Math.min(100, (left / total) * 100)).toFixed(1) + '%';
      if (left <= 60000) el.classList.add('is-urgent'); else el.classList.remove('is-urgent');
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- kampagne-nedtælling i toppen ---------- */
  function initAnnouncement(el) {
    if (el.dataset.on) return;
    el.dataset.on = '1';
    var target = new Date(el.dataset.until).getTime();
    var out = el.querySelectorAll('[data-cd]');
    if (!target || !out.length) return;
    function tick() {
      var ms = Math.max(0, target - Date.now());
      var v = {
        d: Math.floor(ms / 86400000),
        h: Math.floor(ms / 3600000) % 24,
        m: Math.floor(ms / 60000) % 60,
        s: Math.floor(ms / 1000) % 60
      };
      out.forEach(function (n) { n.textContent = pad(v[n.dataset.cd] || 0); });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- galleri ---------- */
  function initGallery(root) {
    if (root.dataset.on) return;
    root.dataset.on = '1';
    var track = root.querySelector('[data-gal-track]');
    var sel = root.querySelector('[data-v-select]');
    var hid = root.querySelector('[data-v-id]');

    function applyOpt(op) {
      if (!op) return;
      if (hid) hid.value = op.value;
      if (dot2 && op.dataset.swatch) dot2.style.background = op.dataset.swatch;
      if (dot && op.dataset.swatch) dot.style.background = op.dataset.swatch;
      if (desc && op.dataset.desc) desc.textContent = op.dataset.desc;
      if (price) price.textContent = op.dataset.price || '';
      if (btnP) btnP.textContent = op.dataset.price || '';
      if (compare) {
        if (op.dataset.hasCompare === '1') { compare.textContent = op.dataset.compare; compare.hidden = false; }
        else compare.hidden = true;
      }
      if (btn) btn.disabled = op.dataset.available !== '1';
      if (track && op.dataset.img !== undefined) {
        var i = parseInt(op.dataset.img, 10);
        if (!isNaN(i)) track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
      }
    }

    if (sel) {
      sel.addEventListener('change', function () { applyOpt(sel.options[sel.selectedIndex]); });
      applyOpt(sel.options[sel.selectedIndex]);
    }
    var thumbs = root.querySelectorAll('[data-gal-thumb]');
    if (!track) return;
    function mark() {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      thumbs.forEach(function (t, j) { t.classList.toggle('is-on', j === i); });
    }
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-gal-thumb]');
      if (t) { track.scrollTo({ left: track.clientWidth * parseInt(t.dataset.galThumb, 10), behavior: 'smooth' }); return; }
      var n = e.target.closest('[data-gal-nav]');
      if (n) track.scrollBy({ left: (n.dataset.galNav === 'next' ? 1 : -1) * track.clientWidth, behavior: 'smooth' });
    });
    track.addEventListener('scroll', function () {
      clearTimeout(track._t);
      track._t = setTimeout(mark, 90);
    }, { passive: true });
    mark();
  }

  /* ---------- varianter ---------- */
  function initVariants(form) {
    if (form.dataset.on) return;
    form.dataset.on = '1';
    var root = form.closest('[data-pdp]') || document;
    var name = root.querySelector('[data-v-name]');
    var desc = root.querySelector('[data-v-desc]');
    var dot = root.querySelector('[data-v-dot]');
    var dot2 = root.querySelector('[data-v-dot2]');
    var price = root.querySelector('[data-v-price]');
    var compare = root.querySelector('[data-v-compare]');
    var btnP = root.querySelector('[data-v-btnprice]');
    var btn = root.querySelector('[data-v-submit]');
    var track = root.querySelector('[data-gal-track]');
    var sel = root.querySelector('[data-v-select]');
    var hid = root.querySelector('[data-v-id]');

    function applyOpt(op) {
      if (!op) return;
      if (hid) hid.value = op.value;
      if (dot2 && op.dataset.swatch) dot2.style.background = op.dataset.swatch;
      if (dot && op.dataset.swatch) dot.style.background = op.dataset.swatch;
      if (desc && op.dataset.desc) desc.textContent = op.dataset.desc;
      if (price) price.textContent = op.dataset.price || '';
      if (btnP) btnP.textContent = op.dataset.price || '';
      if (compare) {
        if (op.dataset.hasCompare === '1') { compare.textContent = op.dataset.compare; compare.hidden = false; }
        else compare.hidden = true;
      }
      if (btn) btn.disabled = op.dataset.available !== '1';
      if (track && op.dataset.img !== undefined) {
        var i = parseInt(op.dataset.img, 10);
        if (!isNaN(i)) track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
      }
    }

    if (sel) {
      sel.addEventListener('change', function () { applyOpt(sel.options[sel.selectedIndex]); });
      applyOpt(sel.options[sel.selectedIndex]);
    }

    var multi = form.querySelector('[data-multi]');
    if (multi) {
      var vs = [];
      try { vs = JSON.parse(multi.querySelector('[data-variants]').textContent); } catch (err) {}
      multi.addEventListener('change', function (e) {
        var r = e.target.closest('[data-opt]');
        if (!r) return;
        var oi = r.dataset.opt;
        multi.querySelectorAll('[data-opt="' + oi + '"]').forEach(function (x) { x.closest('label').classList.toggle('is-on', x === r); });
        var lab = multi.querySelector('[data-opt-label="' + oi + '"]');
        if (lab) lab.textContent = r.value;
        var chosen = [];
        multi.querySelectorAll('[data-opt]:checked').forEach(function (x) { chosen[parseInt(x.dataset.opt, 10)] = x.value; });
        var match = vs.filter(function (v) { return v.o.every(function (o, i) { return o === chosen[i]; }); })[0];
        if (!match) { if (btn) btn.disabled = true; if (btnP) btnP.textContent = 'indisponible'; return; }
        var hidId = multi.querySelector('[data-v-id]');
        if (hidId) hidId.value = match.id;
        if (price) price.textContent = match.p;
        if (btnP) btnP.textContent = match.p;
        if (compare) { if (match.hc) { compare.textContent = match.c; compare.hidden = false; } else compare.hidden = true; }
        if (btn) btn.disabled = !match.a;
        if (track && match.img !== null) track.scrollTo({ left: track.clientWidth * match.img, behavior: 'smooth' });
        try { var u = new URL(location.href); u.searchParams.set('variant', match.id); history.replaceState(null, '', u); } catch (err) {}
      });
    }

    form.addEventListener('change', function (e) {
      var r = e.target.closest('[data-variant]');
      if (!r) return;
      form.querySelectorAll('[data-variant]').forEach(function (x) {
        x.closest('.ak-sw').classList.toggle('is-on', x === r);
      });
      if (name) name.textContent = r.dataset.title || '';
      if (desc) desc.textContent = r.dataset.desc || '';
      if (dot) { dot.style.background = r.dataset.swatch || ''; dot.style.opacity = r.dataset.opacity || '1'; }
      if (dot2) dot2.style.background = r.dataset.swatch || '';
      if (price) price.textContent = r.dataset.price || '';
      if (btnP) btnP.textContent = r.dataset.price || '';
      if (compare) {
        if (r.dataset.hasCompare === '1') { compare.textContent = r.dataset.compare; compare.hidden = false; }
        else compare.hidden = true;
      }
      if (btn) btn.disabled = r.dataset.available !== '1';
      if (track && r.dataset.img !== undefined) {
        var i = parseInt(r.dataset.img, 10);
        if (!isNaN(i)) track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
      }
    });
  }

  /* ---------- afsløring ved scroll ---------- */
  function initReveal() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var sel = '[data-reveal] > *';
    var obs = new IntersectionObserver(function (entries, o) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); o.unobserve(en.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
    document.querySelectorAll(sel).forEach(function (el, i) {
      if (el.dataset.rv) return;
      el.dataset.rv = '1';
      el.classList.add('ak-reveal');
      el.style.transitionDelay = (Math.min(i, 4) * 55) + 'ms';
      obs.observe(el);
    });
  }

  /* ---------- fast købsbar ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-sticky]');
    var anchor = document.querySelector('[data-sticky-after]');
    if (!bar) return;
    if (!anchor || !('IntersectionObserver' in window)) { bar.classList.add('is-on'); return; }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { bar.classList.toggle('is-on', !en.isIntersecting); });
    }, { threshold: 0, rootMargin: '-40% 0px 0px 0px' }).observe(anchor);
  }

  /* ---------- klik-delegering ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-menu]');
    if (b) {
      var d = document.querySelector('[data-drawer]');
      if (d) { d.hidden = !d.hidden; b.classList.toggle('is-open', !d.hidden); b.setAttribute('aria-expanded', d.hidden ? 'false' : 'true'); }
      return;
    }
    var t = e.target.closest('[data-topic]');
    if (t) {
      var box = t.closest('[data-topics]');
      box.querySelectorAll('[data-topic]').forEach(function (x) { x.classList.toggle('is-on', x === t); });
      var hid = box.parentNode.querySelector('[data-topic-value]');
      if (hid) hid.value = t.dataset.topic;
      return;
    }
    var q = e.target.closest('[data-qty]');
    if (q) {
      var input = q.parentNode.querySelector('input');
      var v = parseInt(input.value || '1', 10);
      input.value = Math.max(1, v + (q.dataset.qty === 'up' ? 1 : -1));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  function boot() {
    document.querySelectorAll('[data-timer]').forEach(initTimer);
    document.querySelectorAll('[data-announcement]').forEach(initAnnouncement);
    document.querySelectorAll('[data-gal]').forEach(initGallery);
    document.querySelectorAll('[data-product-form]').forEach(initVariants);
    initReveal();
    initSticky();
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
